module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.jump('/roleManager/roleAdd')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menuConfig.role.addRole')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "arrdata",
    attrs: {
      "data": _vm.dataList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "rolename",
      "label": _vm.$t('menuConfig.role.name'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "memo",
      "label": _vm.$t('menuConfig.role.mark'),
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('menuConfig.role.model')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((_vm.rights[scope.$index]), function(item, index) {
          return (item) ? _c('el-tag', {
            key: index,
            attrs: {
              "type": "primary"
            }
          }, [_vm._v(_vm._s(item))]) : _vm._e()
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('app_operate'),
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.roleid !== '165d6769-2ff9-4ee0-9edc-be17e52eed07') ? [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('mao_global.btn.edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.editRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('menuConfig.role.updatePermission'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.jump('/roleManager/roleUpdate/' + scope.row.roleid)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-key"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_roleAllot'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.showRoleDialog(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-user"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('mao_global.btn.delete'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteRow(scope.row.roleid, scope.row.rolename, scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)] : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('menuConfig.role.editRole'),
      "visible": _vm.editInfoVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.editInfoVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "id": "editForm",
      "model": _vm.editInfoPreViewData,
      "rules": _vm.editRules
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editInfoPreViewData.roleId),
      expression: "editInfoPreViewData.roleId"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.editInfoPreViewData.roleId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editInfoPreViewData, "roleId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('menuConfig.role.name'),
      "label-width": "120",
      "prop": "roleName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInfoPreViewData.roleName),
      callback: function($$v) {
        _vm.$set(_vm.editInfoPreViewData, "roleName", $$v)
      },
      expression: "editInfoPreViewData.roleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述",
      "label-width": "120",
      "prop": "memo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editInfoPreViewData.memo),
      callback: function($$v) {
        _vm.$set(_vm.editInfoPreViewData, "memo", $$v)
      },
      expression: "editInfoPreViewData.memo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editInfoVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.updateRoleInfo()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.ok')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_roleAllot'),
      "visible": _vm.roleAllot
    },
    on: {
      "update:visible": function($event) {
        _vm.roleAllot = $event
      }
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.roleSubList,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "roleName",
      "label": _vm.$t('app_roleName'),
      "width": ""
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.savePermission()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75dcd989"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/config/roleManager.vue
// module id = 1078
// module chunks = 0